<script setup lang="ts">
import { ref } from 'vue'

interface BenefitItem {
  title: string
  content: string
}

defineProps<{
  items: BenefitItem[]
}>()

const openIndex = ref(0)

function toggle(index: number) {
  openIndex.value = openIndex.value === index ? -1 : index
}
</script>

<template>
  <div class="benefits-accordion">
    <div
      v-for="(item, index) in items"
      :key="index"
      :class="['acc-item', { open: openIndex === index }]"
    >
      <button class="acc-header" @click="toggle(index)">
        <h3>{{ item.title }}</h3>
        <span class="acc-icon">{{ openIndex === index ? '−' : '+' }}</span>
      </button>
      <div :class="['acc-body', { open: openIndex === index }]">
        <div class="acc-body-inner">
          <p>{{ item.content }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.acc-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.acc-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 20px 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
}

.acc-header h3 {
  font-family: 'HNDC', sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
  color: var(--white);
  text-transform: uppercase;
}

.acc-icon {
  font-size: 1.4rem;
  color: var(--pink-bright);
  flex-shrink: 0;
  margin-left: 16px;
}

.acc-body {
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  transition:
    grid-template-rows 0.3s ease,
    opacity 0.3s ease;
}

.acc-body.open {
  grid-template-rows: 1fr;
  opacity: 1;
}

.acc-body-inner {
  overflow: hidden;
}

.acc-body-inner p {
  padding-bottom: 20px;
}

@media (max-width: 768px) {
  .acc-header h3 {
    font-size: 0.95rem;
  }

  .acc-body p {
    font-size: 0.85rem;
  }
}
</style>
